'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentPayuAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M77.7464 17.7512H74.5363C74.185 17.7512 73.9014 17.4672 73.9014 17.1154V13.8614C73.9014 13.5096 74.185 13.2256 74.5363 13.2256H77.7464C78.0977 13.2256 78.3813 13.5096 78.3813 13.8614V17.1154C78.3813 17.4672 78.0952 17.7512 77.7464 17.7512Z",
          fill: "#BCCF00"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M73.4669 13.2257H71.2859C71.0474 13.2257 70.8542 13.0322 70.8542 12.7935V10.5822C70.8542 10.3435 71.0474 10.15 71.2859 10.15H73.4669C73.7053 10.15 73.8986 10.3435 73.8986 10.5822V12.7935C73.8986 13.0322 73.7053 13.2257 73.4669 13.2257Z",
          fill: "#BCCF00"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.40217 19.201H14.0729C18.8816 19.201 21.1204 21.3344 21.1179 25.9102C21.1179 30.4884 18.8791 32.6193 14.0704 32.6193H8.65425V38.8635C8.65425 39.8284 8.34555 40.1375 7.38179 40.1375H7.06555C6.10179 40.1375 5.79309 39.8284 5.79309 38.8635V22.8144C5.79309 20.3142 6.90744 19.201 9.40217 19.201ZM14.0705 29.9432C17.5892 29.9432 18.2568 28.526 18.2568 25.9102C18.2568 22.5631 16.7233 21.9098 14.073 21.9098H9.93937C9.00322 21.9098 8.65687 22.2591 8.65687 23.1939V29.9432H14.0705ZM27.1362 23.8045C25.2865 23.8045 24.1245 24.0356 23.6853 24.1261C22.9072 24.2944 22.581 24.5105 22.581 25.3976V25.6513C22.581 25.9981 22.6312 26.2393 22.7416 26.4077C22.8696 26.6062 23.0779 26.7042 23.3565 26.7042C23.492 26.7042 23.6501 26.6816 23.8384 26.6338C24.2826 26.5233 25.7057 26.2921 27.2592 26.2921C30.0526 26.2921 31.192 27.066 31.192 28.9657V30.6593H27.6683C23.1406 30.6593 21.0299 32.1896 21.0299 35.4713C21.0299 38.6575 23.2084 40.4114 27.1613 40.4114C31.8597 40.4114 33.9553 38.8108 33.9553 35.22V28.9657C33.9629 25.4905 31.7291 23.8045 27.1362 23.8045ZM31.1946 35.1245V32.9233H27.7035C24.8976 32.9233 23.8033 33.6369 23.8033 35.4713C23.8033 37.1448 24.8925 37.9564 27.1363 37.9564C30.5295 37.9564 31.1946 36.9186 31.1946 35.1245ZM49.5112 25.5559L45.882 40.0898C44.8178 44.3514 43.0008 46.1807 39.6075 46.4019C39.5197 46.4094 39.4369 46.4144 39.3591 46.4144C38.6287 46.4144 38.3978 46.0099 38.2623 45.3591L38.1995 45.0776C38.1368 44.7811 38.0991 44.4469 38.2723 44.2157C38.4405 43.9921 38.7391 43.9268 39.2009 43.8866C41.4723 43.6529 42.2428 42.6 43.0008 40.2154C42.6419 40.336 42.2102 40.4013 41.7459 40.4013C39.2486 40.4013 38.581 38.66 38.0188 36.5568L35.0221 25.5634C34.9217 25.1915 34.8565 24.8096 35.0497 24.5558C35.243 24.302 35.622 24.2668 36.0035 24.2668H36.257C37.2006 24.2668 37.562 24.5457 37.808 25.4579L40.7746 36.3558C41.1586 37.7152 41.5426 37.9464 42.5063 37.9464C43.2919 37.9464 43.7512 37.7026 44.0775 36.3633L46.6952 25.4654C46.9035 24.5608 47.2724 24.2693 48.2161 24.2693H48.4997C48.8787 24.2693 49.2551 24.3045 49.4534 24.5558C49.6492 24.802 49.5965 25.1815 49.5112 25.5559ZM70.8468 25.5006V21.3093C70.8468 19.5277 70.1215 19.2061 68.1663 19.2061H67.5514C65.5988 19.2061 64.8735 19.5302 64.8735 21.3093V25.478C64.871 25.488 64.871 25.4956 64.871 25.5056V26.4177C64.871 26.4325 64.8704 26.4473 64.8698 26.4624C64.8691 26.4781 64.8685 26.4941 64.8685 26.5107V32.3303C64.8685 33.0414 64.733 33.6068 64.4493 34.0465C63.9173 34.8682 62.8632 35.2401 61.1766 35.2426C59.4925 35.2401 58.4384 34.8657 57.9063 34.0465C57.6252 33.6068 57.4872 33.0389 57.4872 32.3278V26.5082C57.4872 26.4919 57.4866 26.4768 57.4859 26.4617C57.4853 26.4466 57.4847 26.4316 57.4847 26.4152V25.5031C57.4847 25.4981 57.4841 25.4937 57.4834 25.4893C57.4828 25.4849 57.4822 25.4805 57.4822 25.4755V21.3093C57.4822 19.5277 56.7568 19.2061 54.8042 19.2061H54.1893C52.2367 19.2061 51.5114 19.5302 51.5114 21.3093V25.5006V29.9105V32.3278C51.5114 34.0993 51.913 35.6019 52.6835 36.8106C54.1743 39.155 57.0605 40.4039 61.164 40.4039H61.1791H61.1942C65.2977 40.4039 68.1839 39.155 69.6747 36.8106C70.4477 35.6019 70.8468 34.0993 70.8468 32.3278V29.9105V25.5006Z",
          fill: "url(#paint0_linear_647_1958)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M73.0429 23.8396L68.7186 23.8371C68.2467 23.8371 67.8652 23.4551 67.8652 22.9827L67.8677 18.6004C67.8677 18.128 68.2492 17.7461 68.7211 17.7461L73.0454 17.7486C73.5173 17.7486 73.8988 18.1305 73.8988 18.603L73.8963 22.9852C73.8988 23.4576 73.5148 23.8396 73.0429 23.8396Z",
          fill: "#BCCF00"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_647_1958",
          x1: 5.23167,
          y1: 24.9444,
          x2: 5.23167,
          y2: 52.628,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#BCCF00" }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#438F29" })
          ]
        }
      ) })
    ]
  }
);
const VpPaymentPayuAsset = forwardRef(PaymentPayuAsset);

export { VpPaymentPayuAsset as default };
